export const localValidate = (formState) => {
  let errors = {};
  
  //TODO

  return errors;
};

const LaneSheetHeatRelayTeamsFormValidation = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
};

export default LaneSheetHeatRelayTeamsFormValidation;